/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStep_8Aliases {
  AVATAR_EXAM_INFO = 'avatar-exam-info',
  AVATAR_PSEUDONYM_CONSULTATION = 'avatar-pseudonym-consultation',
  AVATAR_SERVICE_INFO = 'avatar-service-info',
  AVATAR_WAITING_LIST_INFO = 'avatar-waiting-list-info',
  CARD_CONTAINER_BODY_CONSULTATION = 'card-container-body-consultation',
  CARD_CONTAINER_BODY_EXAM = 'card-container-body-exam',
  CARD_CONTAINER_BODY_SERVICE = 'card-container-body-service',
  CARD_CONTAINER_BODY_WAITING_LIST = 'card-container-body-waiting-list',
  CARD_CONTAINER_CONSULTATION = 'card-container-consultation',
  CARD_CONTAINER_EXAM = 'card-container-exam',
  CARD_CONTAINER_EXAM_SEPARATOR_ONE = 'card-container-exam-separator-one',
  CARD_CONTAINER_HEADER_CONSULTATION = 'card-container-header-consultation',
  CARD_CONTAINER_HEADER_EXAM = 'card-container-header-exam',
  CARD_CONTAINER_HEADER_SERVICE = 'card-container-header-service',
  CARD_CONTAINER_HEADER_WAITING_LIST = 'card-container-header-waiting-list',
  CARD_CONTAINER_SEPARATOR_ONE = 'card-container-separator-one',
  CARD_CONTAINER_SERVICE = 'card-container-service',
  CARD_CONTAINER_SERVICE_SEPARATOR_ONE = 'card-container-service-separator-one',
  CARD_CONTAINER_WAITING_LIST = 'card-container-waiting-list',
  CARD_CONTAINER_WAITING_LIST_SEPARATOR_ONE = 'card-container-waiting-list-separator-one',
  CARD_CONTAINER_ZONE_CONSULTATION_DATE = 'card-container-zone-consultation-date',
  CARD_CONTAINER_ZONE_CONSULTATION_INFO = 'card-container-zone-consultation-info',
  CARD_CONTAINER_ZONE_CONSULTATION_LOCATION = 'card-container-zone-consultation-location',
  CARD_CONTAINER_ZONE_CONSULTATION_PRICE = 'card-container-zone-consultation-price',
  CARD_CONTAINER_ZONE_ESTABLISHMENT = 'card-container-zone-establishment',
  CARD_CONTAINER_ZONE_EXAM_ADDITIONAL_INFO = 'card-container-zone-exam-additional-info',
  CARD_CONTAINER_ZONE_EXAM_DATE = 'card-container-zone-exam-date',
  CARD_CONTAINER_ZONE_EXAM_ESTABLISHMENT = 'card-container-zone-exam-establishment',
  CARD_CONTAINER_ZONE_EXAM_INFO = 'card-container-zone-exam-info',
  CARD_CONTAINER_ZONE_EXAM_LOCATION = 'card-container-zone-exam-location',
  CARD_CONTAINER_ZONE_EXAM_PRICE = 'card-container-zone-exam-price',
  CARD_CONTAINER_ZONE_PRICE = 'card-container-zone-price',
  CARD_CONTAINER_ZONE_SCHEDULE_TYPE = 'card-container-zone-schedule-type',
  CARD_CONTAINER_ZONE_SERVICE_ADDITIONAL_INFO = 'card-container-zone-service-additional-info',
  CARD_CONTAINER_ZONE_SERVICE_DATE = 'card-container-zone-service-date',
  CARD_CONTAINER_ZONE_SERVICE_ESTABLISHMENT = 'card-container-zone-service-establishment',
  CARD_CONTAINER_ZONE_SERVICE_INFO = 'card-container-zone-service-info',
  CARD_CONTAINER_ZONE_SERVICE_LOCATION = 'card-container-zone-service-location',
  CARD_CONTAINER_ZONE_WAITING_LIST_ADDITIONAL_INFO = 'card-container-zone-waiting-list-additional-info',
  CARD_CONTAINER_ZONE_WAITING_LIST_DATE = 'card-container-zone-waiting-list-date',
  CARD_CONTAINER_ZONE_WAITING_LIST_ESTABLISHMENT = 'card-container-zone-waiting-list-establishment',
  CARD_CONTAINER_ZONE_WAITING_LIST_INFO = 'card-container-zone-waiting-list-info',
  CARD_CONTAINER_ZONE_WAITING_LIST_LOCATION = 'card-container-zone-waiting-list-location',
  CARD_CONTAINER_ZONE_WAITING_LIST_PRICE = 'card-container-zone-waiting-list-price',
  DECK_SUMMARY_CONSULTATION = 'deck-summary-consultation',
  DECK_SUMMARY_EXAM = 'deck-summary-exam',
  DECK_SUMMARY_SERVICE = 'deck-summary-service',
  DECK_SUMMARY_WAITING_LIST = 'deck-summary-waiting-list',
  LAYOUT_SUMMARY = 'layout-summary',
  LOADER = 'loader',
  MAPPER_CONSULTATION_AVATAR = 'mapper-consultation-avatar',
  MAPPER_CONSULTATION_DATE = 'mapper-consultation-date',
  MAPPER_CONSULTATION_LOCATION = 'mapper-consultation-location',
  MAPPER_CONSULTATION_LOCATION_DETAILS = 'mapper-consultation-location-details',
  MAPPER_CONSULTATION_PRICE = 'mapper-consultation-price',
  MAPPER_CONSULTATION_SCHEDULE_TYPE = 'mapper-consultation-schedule-type',
  MAPPER_CONSULTATION_TIME = 'mapper-consultation-time',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_EXAM_DATE = 'mapper-exam-date',
  MAPPER_EXAM_ESTABLISHMENT = 'mapper-exam-establishment',
  MAPPER_EXAM_INFO_AVATAR = 'mapper-exam-info-avatar',
  MAPPER_EXAM_LOCATION = 'mapper-exam-location',
  MAPPER_EXAM_LOCATION_DETAILS = 'mapper-exam-location-details',
  MAPPER_EXAM_SCHEDULE_PRICE = 'mapper-exam-schedule-price',
  MAPPER_EXAM_SCHEDULE_TYPE = 'mapper-exam-schedule-type',
  MAPPER_EXAM_TIME = 'mapper-exam-time',
  MAPPER_GROUPE_SUMMARY_CONSULTATION = 'mapper-groupe-summary-consultation',
  MAPPER_GROUPE_SUMMARY_EXAM = 'mapper-groupe-summary-exam',
  MAPPER_GROUPE_SUMMARY_SERVICE = 'mapper-groupe-summary-service',
  MAPPER_GROUPE_SUMMARY_WAITING_LIST = 'mapper-groupe-summary-waiting-list',
  MAPPER_SERVICE_DATE = 'mapper-service-date',
  MAPPER_SERVICE_ESTABLISHMENT = 'mapper-service-establishment',
  MAPPER_SERVICE_INFO_AVATAR = 'mapper-service-info-avatar',
  MAPPER_SERVICE_LOCATION = 'mapper-service-location',
  MAPPER_SERVICE_LOCATION_DETAILS = 'mapper-service-location-details',
  MAPPER_SERVICE_PRICE = 'mapper-service-price',
  MAPPER_SERVICE_SCHEDULE_TYPE = 'mapper-service-schedule-type',
  MAPPER_SERVICE_TIME = 'mapper-service-time',
  MAPPER_WAITING_LIST_ADDITIONAL_INFO = 'mapper-waiting-list-additional-info',
  MAPPER_WAITING_LIST_DATE = 'mapper-waiting-list-date',
  MAPPER_WAITING_LIST_ESTABLISHMENT = 'mapper-waiting-list-establishment',
  MAPPER_WAITING_LIST_INFO_AVATAR = 'mapper-waiting-list-info-avatar',
  MAPPER_WAITING_LIST_LOCATION = 'mapper-waiting-list-location',
  MAPPER_WAITING_LIST_LOCATION_DETAILS = 'mapper-waiting-list-location-details',
  MAPPER_WAITING_LIST_PRICE = 'mapper-waiting-list-price',
  MAPPER_WAITING_LIST_TIME = 'mapper-waiting-list-time',
  PANEL_LOADER = 'panel-loader',
  PANEL_SUMMARY_CONSULTATION = 'panel-summary-consultation',
  PANEL_SUMMARY_EXAMS = 'panel-summary-exams',
  PANEL_SUMMARY_PROCEDURES = 'panel-summary-procedures',
  PANEL_SUMMARY_SERVICE = 'panel-summary-service',
  PANEL_SUMMARY_WAITING_LIST = 'panel-summary-waiting-list',
  TAG_EXAM_SCHEDULE_TYPE = 'tag-exam-schedule-type',
  TAG_SCHEDULE_TYPE = 'tag-schedule-type',
  TAG_SERVICE_SCHEDULE_TYPE = 'tag-service-schedule-type',
  TAG_WAITING_LIST_SCHEDULE_TYPE = 'tag-waiting-list-schedule-type',
  TEXT_CONSULTATION_PRICE = 'text-consultation-price',
  TEXT_CONSULTATION_TITLE = 'text-consultation-title',
  TEXT_DATE = 'text-date',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_EXAM_DATE = 'text-exam-date',
  TEXT_EXAM_ESTABLISHMENT = 'text-exam-establishment',
  TEXT_EXAM_LOCATION = 'text-exam-location',
  TEXT_EXAM_LOCATION_DETAILS = 'text-exam-location-details',
  TEXT_EXAM_PRICE = 'text-exam-price',
  TEXT_EXAM_TIME = 'text-exam-time',
  TEXT_EXAMS_TITLE = 'text-exams-title',
  TEXT_LOCATION = 'text-location',
  TEXT_LOCATION_DETAILS = 'text-location-details',
  TEXT_SERVICE_DATE = 'text-service-date',
  TEXT_SERVICE_ESTABLISHMENT = 'text-service-establishment',
  TEXT_SERVICE_LOCATION = 'text-service-location',
  TEXT_SERVICE_LOCATION_DETAILS = 'text-service-location-details',
  TEXT_SERVICE_PRICE = 'text-service-price',
  TEXT_SERVICE_TIME = 'text-service-time',
  TEXT_SERVICE_TITLE = 'text-service-title',
  TEXT_TIME = 'text-time',
  TEXT_WAITING_LIST = 'text-waiting-list',
  TEXT_WAITING_LIST_DATE = 'text-waiting-list-date',
  TEXT_WAITING_LIST_ESTABLISHMENT = 'text-waiting-list-establishment',
  TEXT_WAITING_LIST_LOCATION = 'text-waiting-list-location',
  TEXT_WAITING_LIST_LOCATION_DETAILS = 'text-waiting-list-location-details',
  TEXT_WAITING_LIST_PRICE = 'text-waiting-list-price',
  TEXT_WAITING_LIST_TIME = 'text-waiting-list-time',
}
export { PseudonymAppointmentsStep_8Aliases };
